import { IGetDashboardEPIInfoUseCase } from "../../../presentation/useCases/read/get_dashboard_epi_info_use_case";
import { DashboardEPIInfo } from "../../models/dashboard_epi_info";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class GetDashboardEPIInfoUseCase implements IGetDashboardEPIInfoUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async execute(): Promise<DashboardEPIInfo> {
    return await this.repository.getDashboardEPIInfo();
  }

}
